import { Injectable } from '@angular/core';
import { WorkItemTypes } from 'common/workitems/constants/workitem-types';
import { OperatorsService } from 'common/operators/operators.service';

@Injectable()
export class TransferPanelService {

  constructor(private bcOperatorsService: OperatorsService) {
  }

  escalateChats(workItemIds, workItemType, assignee) {
    return this.bcOperatorsService.escalateChats(workItemIds, assignee.id, assignee.selectedItemType);
  }

  assignWorkItem(workItemId, workItemType, assignee) {
    let assignFunction;
    assignFunction = this._getSingleAssignFunction(workItemType);

    return this.bcOperatorsService[assignFunction](workItemId, assignee.id, assignee.selectedItemType);
  }

  bulkAssignWorkItems(workItemIds, workItemType, assignee) {
    let assignFunction;
    assignFunction = this._getBulkAssignFunction(workItemType);

    return this.bcOperatorsService[assignFunction](workItemIds, assignee.id, assignee.selectedItemType);
  }

  _getSingleAssignFunction(workItemType): string {
    let assignFunction;
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        assignFunction = 'assignChat';
        break;
      case WorkItemTypes.EMAIL:
        assignFunction = 'assignEmail';
        break;
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        assignFunction = 'assignTextChat';
        break;
      default:
        throw new Error('Unhandled workItem type in transfer panel service');
    }

    return assignFunction;
  }

  _getBulkAssignFunction(workItemType): string {
    let assignFunction;
    assignFunction = 'escalateChats';
    switch (workItemType) {
      case WorkItemTypes.CHAT:
        assignFunction = 'assignChats';
        break;
      case WorkItemTypes.EMAIL:
        assignFunction = 'assignEmails';
        break;
      case WorkItemTypes.SMS:
      case WorkItemTypes.FACEBOOK:
      case WorkItemTypes.ASYNC_MESSAGE:
        assignFunction = 'assignTextChats';
        break;
      default:
        throw new Error('Unhandled workItem type in transfer panel service');
    }
    return assignFunction;
  }
}
